import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";
import { PrinterType } from "../models/printer-type.model";

const BASE_URL = `${BACKEND_URI}/api/printerType`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;

@Injectable({providedIn: 'root'})
export class PrinterTypeService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    
    async getAll(): Promise<PrinterType[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<PrinterType[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<PrinterType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<PrinterType>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: PrinterType): Promise<PrinterType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<PrinterType>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: PrinterType): Promise<PrinterType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<PrinterType>(UPDATE_URL(id), data)
            );
        }
    }


    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            }catch(err) {}
            } 
        }      
    }